export default __webpack_public_path__ + "static/media/block-user.f26d1501.svg";